module.exports = __webpack_public_path__ + "static/img/ranking_all_reward_kuang_title.82ba9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ranking_all_reward_kuang_title.png
// module id = DZdE
// module chunks = 0